
//const URL_API = "http://localhost:8080/gateway/";
//export const TOKEN_URL = "http://localhost:8080/gateway/auth/login";

// const HOST = "http://192.168.0.39:";
// const PORT_API = "8080";

// const HOST = "http://ec2-54-87-16-66.compute-1.amazonaws.com:";
// const PORT_API = "8080";

// const PORT_AUTH = "8082";

// const GATEWAY = "8080/gateway/"

// const HOST_AUTH = HOST + PORT_AUTH + "/";
// const HOST_API = HOST + PORT_API + "/";



// const HOST = "http://192.168.0.39:"; // localhost
// const HOST = "http://192.168.0.164:"; // localhost
// const HOST = "http://ec2-54-87-16-66.compute-1.amazonaws.com:";
// const HOST = "http://ec2-3-85-137-106.compute-1.amazonaws.com:";
// const HOST = "http://3.219.254.36:"; // SERVER AWS EC2
// const HOST = "https://ALB-minerbook-2122347687.us-east-1.elb.amazonaws.com";
const HOST = "https://services.minerbook.com.br";


const GATEWAY_PORT = ""
// const GATEWAY_PORT = "8080"
const GATEWAY_ALIAS = "/gateway"
// const GATEWAY_ALIAS = ""

const HOST_AUTH = HOST + GATEWAY_PORT + GATEWAY_ALIAS + "/";
// const HOST_AUTH = HOST + "8082" + GATEWAY_ALIAS + "/";
const HOST_API = HOST + GATEWAY_PORT + GATEWAY_ALIAS + "/";
//http://3.219.254.36:8080/gateway/





//const URL_API = HOST + "gateway/";
//export const TOKEN_URL = HOST + "gateway/auth/login"; 
const URL_API = HOST_API;
export const TOKEN_URL = HOST_AUTH + "auth/login"; 
//http://3.219.254.36:8080/gateway/auth/login

export const VALIDA_TOKEN_URL = URL_API + "validaToken";
export const TOKEN_KEY = "HC4Sb5x4if_mORl7ICvzg_zcEy7D1n";
export const TOKEN_KEY_REMEMBER_ME = "Kibkf8Slmue6KlTjTK7F1b9t0sgFOu";
export const TOKEN_ROLES = "q78M6oUUFRuduA2kaGYpz9WQSnVS7w";
export const TOKEN_FIRST_NAME = "P4S0OGu1Nt01dy6cQz5RjYcXhgyVqB";
export const TOKEN_LAST_NAME = "EDDZLL_fSbs3o47d0Mn22MMQLVKFTF";
export const TOKEN_USER_NAME = "oJdbbUaFow-WaAnA1m1RztZQa_Hrre";
export const TOKEN_USER_ID = "SUTJ2e73DdKTThIAG_VaXiArFrFupv";
export const DATA_USER = "mlVsTaS1zk4DJg6sO1_QrgRx8ryNbJ";
export const CHAT_CONTACT = "mlVsTaS1zk4DJg6sO1_QigRx8ryNbJ";
export const INTERVAL = "mlVsTaSizk4DJg6sO1_QigRx8ryNbJ";
export const STATE_FILTER = "mlVsTa81zk4DJg6sO1_QigRxBryNbJ";
export const CITY_FILTER = "mlVsTaS1zk4DJg6sO1_QigRxBryNbJ";
export const TOKEN_RESET_PASSWORD = "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..GzbxFGh6a0keJqDsVlBzvA.HLW9FoQ8Tl2pihVUJiHo2vPD9H-D6HOO7lwFG6xx7zBqHu7WtRxb-BjnQJJW3xqXdM52Gw6G1K8immzDe_3R0O6_cTYg5vyl56ztjsUEYol2fGeKzTTyGCxj7j_v7HLiRZW3MCqnMy7dNW1-kuadwuzVr5U-_4eiJrPfpKQFZGAKG2ux3RSWwIlxbvi6A9NY9Ac3_ez4gUVvzsinRG0neDws5ATgL3NrMTu18Zg4YRtGY1TfdmrDuCjRBofbjZytqXWsahy2Put-PdDxFmOkd0lvFatwCw4EkbHGF-iZPZkGl9vgUkU2Lgj886hx2Bi0tVCe_0k1Y-66F-WvrYOZydG7H4nIxAJW4_PBc4UGvdpx14FF_VrfGO4J4niQhHdHwnY6MKz7rkdy6rFrX7vOu_jREkG5BhPIIaq_ixx9PfxqgBEKMz72NiHuoRG0cNcyLC2Y0v6xPe6xM7aXLFIvJL2DR_81fR8OoHytdcpdUabCje-5YeN3ADyGPtqe6gLluhLecLz6vo3xdR2p9dTXWWWjGxvdUdrlFDwnnevhECTh0tD8GVWwaHg278N0h0vEZNHO1tpR85CCkhtRhHUxWyV9M2YqMMFFQSqN9aC2Fhx5QOUR4135Q73-wt7VIaZt5wYq0sDD4o6KdqMibsN5c6m5VeBCKxCGv9acnRVaohGEJIwBJCvehSv6-CtnOPdkWiNm_o4bIeoAkiPmSFzOLSk20IolSwvM08ZL8YAXvF7eBCeheM3hIckmmk5zHjvoQW80cAjplIrmYDmPsCue8xgx9vZ04jjDlm4Bc8a4jvLNriQsV6sREB0Gu7d8Vl1k_LHZOO3veBVwP3XAeqw5LgW9v-PLyfcud1lWOs4oJdDw-sf0sXd9QNoDA1n7mqRgfEh0nVH1ZrATGCi0MzIvN7dxDEQNqdgYQPRqBHssgjkmoTGnLbSyT-ddkzej6QC8lccqEuqW1F7jc-1yiPpQiiYfV29hpVU2T53ylq-acLcsQBoofX_BFCvClaZKoVQ5HUED2yZp5HmVMNtSV2QvwjndoPLUYST70xTRKUcxPTY8e4_u9i_Y6kilBOuVEDog3fToHEexD25ta3ARdJZHSAlqQiuvMoSTBFKq8oigJEJoMb8u36VS4U2IQNL9vUl2qFfJUzSRvQvQ1b02e7Rzj8KTgKjRtUJZlYVLKCddsbaStUrOCZ_xiNHW84ukuzK0Mgc57A0KkC87L1qttmU2pU8DI-8KtkeBlSSufLdFXsPYr-nzCgMqwfHBWIo5-9XiAIIZ-c2iqeEv9UIKaOlJE8p7fRkFKHh5QTh1b7pV0XUz-VkQrZ1TaxIninTF94mFTZ-hzTIALNvnjGDNJfPnFXV0uK5vSsgwwFpJCoO4xTzFKx8db1zpXf_Wk5qv6ixRwvGAWYENjI6GkJAN_wNUOO6EwAwHdTLy6YTzWp7buDTi0a6bbUYXBEW2Dd9fOBfftqRiJIMyFIwp6NHgYqYo_8kX3LYbKWJB4p1wR9uKfB54iJee_1XQJF0GT57QfzT8.Xv7Id05VP1yh05gnrVvdGg";
export const USER = "_USER_";
export const USERm = "Usuário";
export const CLIENT = "_CLIENT_";
export const CLIENTm = "Cliente";
export const CLIENT_ADMIN = "_CLIENT_ADMIN_";
export const CLIENT_ADMINm = "Cliente Admin";
export const ADMIN = "_ADMIN_";
export const ADMINm = "Administrador";
export const LANGUAGE = "LANGUAGE";
export const BASE_CALC_DAILY = 23;

export const HEADER_CSV = {
    responseType: 'blob',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY)
      },
}

export const HEADER = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY)
      },
}

export const HEADER_FORM_DATA = {
    headers: {
        //'content-type': 'multipart/form-data',
        'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY)
      },
}

export const environment = {
    getApi,
    getUser,
    getUserName,
    getUserPermissions,
    getUserGroups,
    getUserOrgaos,
    getStateFilter,
    getCityFilter,
    getUserCities,
    getUserStateCities,
    isAdmin,
    isClientAdmin,
    isClient,
    isUser,
    URL_API,
    HOST_AUTH,
    TOKEN_URL,
    VALIDA_TOKEN_URL,
    TOKEN_KEY,
    TOKEN_KEY_REMEMBER_ME,
    TOKEN_ROLES,
    TOKEN_FIRST_NAME,
    TOKEN_LAST_NAME,
    TOKEN_USER_NAME,
    TOKEN_USER_ID,
    DATA_USER,
    CHAT_CONTACT,
    INTERVAL,
    STATE_FILTER,
    CITY_FILTER,
    TOKEN_RESET_PASSWORD,
    CLIENT,
    CLIENT_ADMIN,
    ADMIN,
    USER,
    HEADER_CSV,
    HEADER,
    HEADER_FORM_DATA,
    getProfileName,
    getProfileNameLng,
    LANGUAGE,
    BASE_CALC_DAILY
};

function getApi(path) {
    return URL_API + "api/" + path;
    //http://3.219.254.36:8080/gateway/api/
}

function getUser(){
    return JSON.parse(localStorage.getItem(DATA_USER));
}

function getUserName(){
    let user =  this.getUser();
    return user.name;
}

function getUserPermissions(){
    let user =  this.getUser();
    return user.permissions;
}

function getUserGroups(){
    let user =  this.getUser();
    return user.groups;
}

function getUserOrgaos(){
    let user =  this.getUser();
    return user.orgaos;
}

function getStateFilter(){
    return localStorage.getItem(STATE_FILTER);
}

function getCityFilter(){
    return localStorage.getItem(CITY_FILTER);
}

function getUserCities(){
    let orgaos =  this.getUserOrgaos();
    let cities = [];
    if(orgaos.length > 0){
        let exists = false;
        for(let i = 0; i < orgaos.length; i++){
            exists = false;
            for(let j = 0; j < cities.length; j++){
                if(cities[j].id === orgaos[i].cidade.id){
                    exists = true;
                }
            }
            if(!exists){
                cities.push(orgaos[i].cidade);
            }
        }
    }
    return cities;
}

function getUserStateCities(){
    let orgaos =  this.getUserOrgaos();
    let states = [];
    let cities = [];
    if(orgaos.length > 0){
        let exists = false;
        for(let i = 0; i < orgaos.length; i++){
            exists = false;
            for(let j = 0; j < states.length; j++){
                if(states[j].id === orgaos[i].estado.id){
                    for(let c = 0; c < states[j].cidades.length; c++){
                        if(states[j].cidades[c].id === orgaos[i].cidade.id){
                            exists = true;
                            break;
                        }
                    }
                    if(!exists){
                        states[j].cidades.push(orgaos[i].cidade);
                    }
                    exists = true;
                    break;
                }
            }
            if(!exists){
                cities = [];
                cities.push(orgaos[i].cidade);
                let state = orgaos[i].estado;
                state.cidades = cities;
                states.push(state);
            }
        }
    }
    return states;
}

function isAdmin(){
    if((localStorage.getItem(TOKEN_ROLES) !== undefined && localStorage.getItem(TOKEN_ROLES) !== null) &&
        localStorage.getItem(TOKEN_ROLES).indexOf(ADMIN) >= 0){
      return true
    }
    return false;
}

function isClientAdmin(){
    if((localStorage.getItem(TOKEN_ROLES) !== undefined && localStorage.getItem(TOKEN_ROLES) !== null) &&
        localStorage.getItem(TOKEN_ROLES).indexOf(CLIENT_ADMIN) >= 0){
      return true;
    }
    return false;
}

function isClient(){
    if((localStorage.getItem(TOKEN_ROLES) !== undefined && localStorage.getItem(TOKEN_ROLES) !== null) &&
        localStorage.getItem(TOKEN_ROLES).indexOf(CLIENT) >= 0){
      return true;
    }
    return false;
}

function isUser(){
    if((localStorage.getItem(TOKEN_ROLES) !== undefined && localStorage.getItem(TOKEN_ROLES) !== null) &&
        localStorage.getItem(TOKEN_ROLES).indexOf(USER) >= 0){
      return true;
    }
    return false;
}

function getProfileName(){
    if(this.isAdmin()){
        return ADMINm;
    }else if(this.isClientAdmin()){
        return CLIENT_ADMINm;
    }else if(this.isClient()){
        return CLIENTm;
    }else {
        return USERm;
    }
}

function getProfileNameLng(){
    if(this.isAdmin()){
        return "ADMIN";
    }else if(this.isClientAdmin()){
        return "CLIENT_ADMIN";
    }else if(this.isClient()){
        return "CLIENT";
    }else {
        return "USER";
    }
}